import { LitElement as u, unsafeCSS as n } from "lit";
import { property as l } from "lit/decorators.js";
import y from "../../foundations/icon/icon.style.css.js";
import f from "../../shared/scrollbar.style.css.js";
import { booleanType as h } from "../../utils/property-types.js";
import g from "../button/button.style.css.js";
import S from "../icon-button/icon-button.style.css.js";
import v from "./modal.style.css.js";
import { modalTemplate as w } from "./modal.template.js";
var C = Object.defineProperty, H = Object.getOwnPropertyDescriptor, i = (c, e, t, o) => {
  for (var s = o > 1 ? void 0 : o ? H(e, t) : e, a = c.length - 1, d; a >= 0; a--)
    (d = c[a]) && (s = (o ? d(e, t, s) : d(s)) || s);
  return o && s && C(e, t, s), s;
};
const b = 250;
class r extends u {
  constructor() {
    super(), this.fullHeight = !1, this.fullWidth = !1, this.flexBody = !1, this.removeBodyPadding = !1, this.jcef = !1, this._open = !1, this._modalTitle = "Title", this._state = "", this._hideCloseIcon = !1, this._hasScroll = !1, this._modalStyle = void 0, this._scrollHandler = null, this._scrollContainer = null, this._modalHeader = null, this._modalFooter = null, this._handleKeydown = this._handleKeydown.bind(this), this._handleOutsideClick = this._handleOutsideClick.bind(this), this._scrollHandler = this._handleScroll.bind(this);
  }
  static get styles() {
    return [
      n(y),
      n(f),
      n(g),
      n(S),
      n(v)
    ];
  }
  set open(e) {
    const t = this._open;
    this._open = e, this.requestUpdate("open", t);
  }
  get open() {
    return this._open;
  }
  set modalTitle(e) {
    const t = this._modalTitle;
    this._modalTitle = e, this.requestUpdate("modalTitle", t);
  }
  get modalTitle() {
    return this._modalTitle;
  }
  set state(e) {
    const t = this._state;
    this._state = e, this.requestUpdate("state", t);
  }
  get state() {
    return this._state;
  }
  set hideCloseIcon(e) {
    const t = this._hideCloseIcon;
    this._hideCloseIcon = e, this.requestUpdate("hideCloseIcon", t);
  }
  get hideCloseIcon() {
    return this._hideCloseIcon;
  }
  set hasScroll(e) {
    const t = this._hasScroll;
    this._hasScroll = e, this.requestUpdate("hasScroll", t);
  }
  get hasScroll() {
    return this._hasScroll;
  }
  set modalStyle(e) {
    const t = this._modalStyle;
    this._modalStyle = e, this.requestUpdate("modalStyle", t);
  }
  get modalStyle() {
    return this._modalStyle || "";
  }
  get _headerSlot() {
    var t;
    const e = ((t = this.shadowRoot) == null ? void 0 : t.querySelector('slot[name="header"]')) || void 0;
    return e == null ? void 0 : e.assignedElements()[0];
  }
  get _footerSlot() {
    var t;
    const e = ((t = this.shadowRoot) == null ? void 0 : t.querySelector('slot[name="footer"]')) || void 0;
    return e == null ? void 0 : e.assignedElements()[0];
  }
  connectedCallback() {
    super.connectedCallback(), document.addEventListener("mousedown", this._handleOutsideClick);
  }
  disconnectedCallback() {
    super.disconnectedCallback(), document.removeEventListener("mousedown", this._handleOutsideClick), this._scrollContainer && this._scrollHandler && this._scrollContainer.removeEventListener("scroll", this._scrollHandler), this._scrollContainer = null;
  }
  updated(e) {
    e.has("open") && (this._open ? this._showDialog() : this._hideDialog());
  }
  _showDialog() {
    this.classList.add("show"), this.classList.remove("hide"), setTimeout(() => {
      this.classList.add("show"), this.style.visibility = "visible";
    }, 0), document.addEventListener("keydown", this._handleKeydown), document.body.style.overflow = "hidden";
  }
  _hideDialog() {
    this.classList.add("hide"), this.classList.remove("show"), setTimeout(() => {
      this.classList.remove("hide"), this.style.visibility = "hidden", document.removeEventListener("keydown", this._handleKeydown);
    }, b), document.body.style.overflow = "";
  }
  _close() {
    this.open = !1, this._hideDialog(), this.requestUpdate();
    const e = new Event("onModalClosed");
    this.dispatchEvent(e);
    const t = new Event("onClose");
    this.dispatchEvent(t);
  }
  _isStateValid() {
    return this._state === "danger" || this._state === "error" || this._state === "warning" || this._state === "alert";
  }
  _getStateIcon() {
    let e = "";
    switch (this._state) {
      case "danger":
        e = "warning";
        break;
      case "error":
        e = "warning";
        break;
      case "warning":
        e = "error";
        break;
      case "alert":
        e = "error";
        break;
      default:
        e = "";
    }
    return e;
  }
  _handleKeydown(e) {
    e.key === "Escape" && this._close();
  }
  _handleOutsideClick(e) {
    var t;
    if (this._open) {
      const o = (t = this.shadowRoot) == null ? void 0 : t.querySelector(".dss-dialog"), s = e.composedPath();
      o && s.includes(this) && !s.includes(o) && this._close();
    }
  }
  fixEmptyFooter() {
    var t;
    const e = (t = this.shadowRoot) == null ? void 0 : t.querySelector(".dss-dialog");
    e != null && e.classList.contains("dss-dialog--footer-empty") && this.requestUpdate();
  }
  _handleScroll(e) {
    var o, s, a, d;
    const t = e.target;
    t && (t.scrollTop > 0 ? (o = this._modalHeader) == null || o.classList.add("dss-dialog-header--scrolled") : (s = this._modalHeader) == null || s.classList.remove("dss-dialog-header--scrolled"), t.scrollHeight - t.scrollTop !== t.clientHeight ? (a = this._modalFooter) == null || a.classList.add("dss-dialog-footer--scrolled") : (d = this._modalFooter) == null || d.classList.remove("dss-dialog-footer--scrolled"));
  }
  async firstUpdated() {
    var t, o, s, a, d;
    await this.updateComplete, this._footerSlot && this.fixEmptyFooter();
    const e = (t = this.shadowRoot) == null ? void 0 : t.querySelector(".dss-dialog-body");
    if (this._hasScroll && e) {
      this._scrollContainer = e, this._scrollHandler && this._scrollContainer.addEventListener("scroll", this._scrollHandler), this._modalHeader = (o = this.shadowRoot) == null ? void 0 : o.querySelector(".dss-dialog-header"), this._modalFooter = (s = this.shadowRoot) == null ? void 0 : s.querySelector(".dss-dialog-footer");
      const _ = this._modalHeader ? this._modalHeader.clientHeight : 0, p = this._modalFooter ? this._modalFooter.clientHeight : 0, m = (((d = (a = this.shadowRoot) == null ? void 0 : a.querySelector(".dss-dialog")) == null ? void 0 : d.clientHeight) || 0) - _ - p;
      e.scrollHeight > m && this._modalFooter.classList.add("dss-dialog-footer--scrolled");
    }
  }
  render() {
    return w(this);
  }
}
i([
  l(h)
], r.prototype, "open", 1);
i([
  l({ type: String })
], r.prototype, "modalTitle", 1);
i([
  l({ type: String })
], r.prototype, "state", 1);
i([
  l(h)
], r.prototype, "hideCloseIcon", 1);
i([
  l(h)
], r.prototype, "hasScroll", 1);
i([
  l({ type: String })
], r.prototype, "modalStyle", 1);
i([
  l(h)
], r.prototype, "fullHeight", 2);
i([
  l(h)
], r.prototype, "fullWidth", 2);
i([
  l(h)
], r.prototype, "flexBody", 2);
i([
  l(h)
], r.prototype, "removeBodyPadding", 2);
i([
  l(h)
], r.prototype, "jcef", 2);
export {
  r as Modal
};
//# sourceMappingURL=modal.js.map
